'use client'

import { useRef, useState } from 'react'
import { Play, Pause, Volume2, VolumeX } from 'lucide-react'
import { cn } from '@/lib/utils'

export default function AudioPlayer({ src }: { src: string }) {
  const audioRef = useRef<HTMLAudioElement>(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [progress, setProgress] = useState(0)

  // Use simple events for now
  const togglePlay = () => {
    if(!audioRef.current) return
    if (isPlaying) {
        audioRef.current.pause()
    } else {
        audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  const handleTimeUpdate = () => {
      if(!audioRef.current) return
      const current = audioRef.current.currentTime
      const duration = audioRef.current.duration || 1
      setProgress((current / duration) * 100)
  }
  
  const handleEnded = () => {
      setIsPlaying(false)
      setProgress(0)
  }

  return (
    <div className="flex items-center gap-3 bg-white/5 rounded-full px-3 py-1.5 border border-white/10 w-fit">
        <audio 
            ref={audioRef} 
            src={src} 
            onTimeUpdate={handleTimeUpdate}
            onEnded={handleEnded}
        />
        
        <button 
            onClick={togglePlay}
            className="w-8 h-8 rounded-full bg-neon-cyan/20 text-neon-cyan flex items-center justify-center hover:bg-neon-cyan/30 transition-colors"
        >
            {isPlaying ? <Pause className="w-3 h-3 fill-current" /> : <Play className="w-3 h-3 fill-current" />}
        </button>

        <div className="w-20 h-1 bg-white/10 rounded-full overflow-hidden">
            <div 
                className="h-full bg-neon-cyan transition-all duration-100" 
                style={{ width: `${progress}%` }}
            />
        </div>
    </div>
  )
}
